/* sgd-page.js: hides the phone sticky bar while the offer box is on screen */
(function () {
  var bar = document.querySelector('[data-sgd-bar]');
  var offer = document.getElementById('sgd-offer');
  if (!bar || !offer || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    bar.classList.toggle('sgd-bar--hide', entries[0].isIntersecting);
  }, { threshold: 0.2 }).observe(offer);
})();